import { Injectable } from "@angular/core";
import { Store, StoreConfig, akitaConfig } from "@datorama/akita";
import { SessionState } from "../models/session";

export function createInitialState(): SessionState {
	return {
		isAuthenticated: false,
		user: null,
    account: null,
		isMaster : false
	};
}

akitaConfig({
	resettable: true
})

@Injectable({
	providedIn: 'root'
})
@StoreConfig({ name: 'sessionState' })
export class SessionStore extends Store<SessionState> {
	constructor() {
		super(createInitialState());
	}

	clearSession(): void {
		this._setState(state => createInitialState());
	}
}
